export default {"src":"/_next/static/media/searchIcon.61ee58e5.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};